export default {
    // ******************************************
    // Globals
    // ******************************************
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",

    // ******************************************
    // Globals - Locales
    // ******************************************
    locale_ar_ar_label_primary: "Arabic",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "German",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "Greek",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "English",
    locale_en_gb_label_secondary: "British",
    locale_en_us_label_primary: "English",
    locale_en_us_label_secondary: "American",
    locale_es_es_label_primary: "Spanish",
    locale_es_es_label_secondary: "Spain",
    locale_es_la_label_primary: "Spanish",
    locale_es_la_label_secondary: "Latin America",
    locale_fa_ir_label_primary: "Persian",
    locale_fa_ir_label_secondary: "Farsi",
    locale_fr_fr_label_primary: "French",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "Irish",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "Hebrew",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "Italian",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "Japanese",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "Korean",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "Dutch",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "Polish",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "Portuguese",
    locale_pt_br_label_secondary: "Brazil",
    locale_ru_ru_label_primary: "Russian",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "Swedish",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "Filipino",
    locale_tl_ph_label_secondary: "Tagalog",
    locale_tr_tr_label_primary: "Turkish",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "Vietnamese",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "Chinese",
    locale_zn_cn_label_secondary: "Mandarin",

    // ******************************************
    // Nav Primary
    // ******************************************
    nav_primary_blog_label: "Blog",
    nav_primary_catalog_label: "Languages & Pricing",
    nav_primary_catalog_select_language_label: "Select a language",
    nav_primary_contact_label: "Contact",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "Questions?",
    nav_primary_phone_number: "1 (800) 306-3467",
    nav_primary_sign_in_label: "Sign In",
    nav_primary_support_label: "Support",
    nav_primary_switch_language: "Español",
    nav_primary_vertical_consumer_label: "For You",
    nav_primary_vertical_education_for_homeschool_label: "For Homeschool",
    nav_primary_vertical_education_for_students_label: "For Students",
    nav_primary_vertical_education_homeschool_label: "Homeschool",
    nav_primary_vertical_education_primary_label: "For Schools",
    nav_primary_vertical_education_secondary_label: "For Higher Education",
    nav_primary_vertical_education_students_label: "Students",
    nav_primary_vertical_enterprise_label: "For Enterprise",
    nav_primary_vertical_for_young_learners_label: "For Young Learners",

    // ******************************************
    // Nav Secondary - Enterprise
    // ******************************************
    nav_secondary_enterprise_blog_label: "Blog",
    nav_secondary_enterprise_custom_1_label: "",
    nav_secondary_enterprise_home_label: "Home",
    nav_secondary_enterprise_label: "Enterprise",
    nav_secondary_enterprise_resources_label: "Resources",
    nav_secondary_enterprise_solutions_label: "Solutions",

    // Solutions
    nav_secondary_enterprise_solutions_construction_label: "Construction",
    nav_secondary_enterprise_solutions_consulting_label: "Consulting",
    nav_secondary_enterprise_solutions_foodservice_label: "Food Service",
    nav_secondary_enterprise_solutions_government_label: "Government",
    nav_secondary_enterprise_solutions_healthcare_label: "Healthcare",
    nav_secondary_enterprise_solutions_hospitality_label: "Hospitality",
    nav_secondary_enterprise_solutions_manufacturing_label: "Manufacturing",
    nav_secondary_enterprise_solutions_retail_label: "Retail",

    // ******************************************
    // Nav Secondary - Education Primary
    // ******************************************
    nav_secondary_education_primary_blog_label: "Blog",
    nav_secondary_education_primary_home_label: "Home",
    nav_secondary_education_primary_label: "Schools",
    nav_secondary_education_primary_resources_label: "Resources",
    nav_secondary_education_primary_solutions_label: "Solutions",

    // Solutions
    nav_secondary_education_primary_solutions_k12_english_language: "K12 English Language",
    nav_secondary_education_primary_solutions_world_languages: "World Languages",

    // ******************************************
    // Nav Secondary - Education Secondary
    // ******************************************
    nav_secondary_education_secondary_blog_label: "Blog",
    nav_secondary_education_secondary_custom_1_label: "",
    nav_secondary_education_secondary_home_label: "Home",
    nav_secondary_education_secondary_label: "Higher Education",
    nav_secondary_education_secondary_resources_label: "Resources",
    nav_secondary_education_secondary_solutions_label: "Solutions",

    // ******************************************
    // Nav Secondary - Education Homeschool
    // ******************************************
    nav_secondary_education_homeschool_blog_label: "Blog",
    nav_secondary_education_homeschool_home_label: "Home",
    nav_secondary_education_homeschool_label: "Homeschool",
    nav_secondary_education_homeschool_resources_label: "Resources",
    nav_secondary_education_homeschool_solutions_label: "Solutions",

    // ******************************************
    // Nav Secondary - Services
    // ******************************************
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",

    // ******************************************
    // Shared - Awards
    // ******************************************
    awards_header_label: "Trusted for 25+ years by top organizations.",
    awards_bmw: "BMW",
    awards_ikea: "Ikea",
    awards_lego: "Lego",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",

    // ******************************************
    // Shared - Branded Quotes
    // ******************************************
    branded_quotes_header_label: "What people say about us.",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote: "&quot;The <em>gold standard</em> of computer-based language learning.&quot;",
    branded_quotes_cnn_type: "cnn",

    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote:
        "&quot;I love Rosetta Stone's software, and I think <em>the approach to learning languages works.</em>&quot;",
    branded_quotes_macworld_type: "macworld",

    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote:
        "&quot;With its excellent user interface, clear instructions, wide variety of games and challenges...  <em>Rosetta Stone has got it going on.</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",

    // ******************************************
    // Shared - Related Resources
    // ******************************************
    related_resources_label: "Keep Exploring",
    related_resources_button_label: "Read more",

    // ******************************************
    // Shared - Verticals
    // ******************************************
    verticals_label: "What type of learner are you?",
    verticals_education_primary: "Schools",
    verticals_education_secondary: "Higher Education",
    verticals_enterprise: "Enterprise",
    verticals_publicsector: "Public Sector",

    // ******************************************
    // Footer
    // ******************************************
    // CTA Form
    footer_cta_email_button: "Sign Up",
    footer_cta_email_main_label: "Sign up to stay in touch.",
    footer_cta_email_placeholder: "Sign Up",
    footer_cta_email_sub_label: "Get Rosetta Stone news and offers.",
    footer_cta_form_comments: "",
    footer_cta_form_country: "Country",
    footer_cta_form_email: "Email Address",
    footer_cta_form_firstname: "First Name",
    footer_cta_form_lastname: "Last Name",
    footer_cta_form_organization: "Organization Name",
    footer_cta_form_organizationsize: "form_organizationsize",
    footer_cta_form_organizationsize_100: "form_100",
    footer_cta_form_organizationsize_500: "form_500",
    footer_cta_form_organizationsize_1000: "form_1000",
    footer_cta_form_organizationsize_5000: "form_5000",
    footer_cta_form_organizationsize_10000: "form_10000",
    footer_cta_form_organizationsize_25000: "form_25000",
    footer_cta_form_organizationsize_50000: "form_50000",
    footer_cta_form_organizationsize_more: "form_more",
    footer_cta_form_phone: "Phone Number (Optional)",
    footer_cta_form_pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
    footer_cta_form_role: "Role (or title)",
    footer_cta_form_role_boardmember: "Board Member",
    footer_cta_form_role_curriculumdirector: "Curriculum Director/Instruction Coordinator",
    footer_cta_form_role_director: "Director",
    footer_cta_form_role_executive: "General Management/Executive",
    footer_cta_form_role_individualcontributor: "Individual Contributor",
    footer_cta_form_role_manager: "Manager",
    footer_cta_form_role_principal: "Principal/Vice Principal",
    footer_cta_form_role_superintendent: "Superintendent/District Administrator",
    footer_cta_form_role_teacher: "Teacher",
    footer_cta_form_role_techcoordinator: "Technology Coordinator",
    footer_cta_form_role_vicepresident: "Vice President",
    footer_cta_form_submit: "Submit",
    footer_cta_pricing_button: "Request Pricing",
    footer_cta_pricing_label: "Ready to begin your organization’s complete language journey?",
    footer_cta_pricing_subtitle: "Please fill out the form below and we'll follow up with you right away.",
    footer_cta_pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
    footer_cta_pricing_title: "Get the pricing answers you need.",

    // Menu
    footer_menu_about_about_us_label: "About Us",
    footer_menu_about_blog_label: "Blog",
    footer_menu_about_careers_label: "Careers",
    footer_menu_about_coaches_label: "Meet Our Coaches",
    footer_menu_about_contact_label: "Contact",
    footer_menu_about_endangered_languages_label: "Endangered Languages",
    footer_menu_about_investor_relationss_label: "Investor Relations",
    footer_menu_about_investors_label: "Investors",
    footer_menu_about_k12_reading_label: "Reading Solutions for K–12",
    footer_menu_about_label: "About",
    footer_menu_about_military_discount_label: "Military Discount",
    footer_menu_about_press_label: "Press",
    footer_menu_about_retail_partners_label: "Retail Partners",
    footer_menu_about_student_discount_label: "Student Discount",
    footer_menu_buy_all_label: "See All Languages",
    footer_menu_buy_english_label: "English",
    footer_menu_buy_espanol_label: "Rosetta Stone Español",
    footer_menu_buy_french_label: "French",
    footer_menu_buy_german_label: "German",
    footer_menu_buy_homeschool_label: "Rosetta Stone Homeschool",
    footer_menu_buy_ingles_label: "Inglés",
    footer_menu_buy_italian_label: "Italian",
    footer_menu_buy_label: "Buy Now",
    footer_menu_buy_portugues_label: "Rosetta Stone Português",
    footer_menu_buy_spanish_label: "Spanish",
    footer_menu_foreign_curriculum_label: "Homeschool Foreign Language Curriculum",
    footer_menu_gifts_label: "Gifts",
    footer_menu_homeschool_program_label: "Homeschool Program",
    footer_menu_homeschool_reviews_label: "Homeschool Reviews",
    footer_menu_homeschool_travel_label: "Homeschool Travel",
    footer_menu_learn_chinese_label: "Learn Chinese",
    footer_menu_learn_english_label: "Learn English",
    footer_menu_learn_french_label: "Learn French",
    footer_menu_learn_german_label: "Learn German",
    footer_menu_learn_ingles_label: "Aprende Inglés",
    footer_menu_learn_italian_label: "Learn Italian",
    footer_menu_learn_japanese_label: "Learn Japanese",
    footer_menu_learn_label: "Learn More",
    footer_menu_learn_languages_label: "Learn a Language",
    footer_menu_learn_spanish_label: "Learn Spanish",
    footer_menu_online_curriculum_label: "Online Homeschool Curriculum",
    footer_menu_products_consumer_label: "For Individuals",
    footer_menu_products_education_homeschool_label: "For Homeschool",
    footer_menu_products_education_primary_label: "For Schools",
    footer_menu_products_enterprise_label: "For Enterprise",
    footer_menu_products_label: "Products",
    footer_menu_start_activation_label: "Product Activation",
    footer_menu_start_blog_label: "Blog",
    footer_menu_start_demo_label: "Try it Free",
    footer_menu_start_education_primary_label: "For Schools",
    footer_menu_start_enterprise_label: "For Enterprise",
    footer_menu_start_homeschool_retailers_label: "Authorized Retailers",
    footer_menu_start_homeschool_reviews_label: "Homeschool Reviews",
    footer_menu_start_label: "Where to Start",
    footer_menu_start_mobile_label: "Mobile Apps",
    footer_menu_start_reviews_label: "Reviews",
    footer_menu_start_speech_label: "Speech Recognition",
    footer_menu_start_testamonials_label: "Testimonials",
    footer_menu_start_translate_label: "Translate",
    footer_menu_support_accessibility_statement_label: "Accessibility Statement",
    footer_menu_support_contact_us_label: "Contact Us",
    footer_menu_support_faqs_label: "FAQs",
    footer_menu_support_label: "Support",
    footer_menu_support_support_site_label: "Support Site",
    footer_menu_support_system_requirements_label: "System Requirements",

    // Meta
    footer_meta_agreements_label: "Agreements",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Cookie Settings",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label: "Rosetta Stone Ltd. All Rights Reserved.",
    footer_meta_privacy_policy_label: "Privacy Policy",
    footer_meta_terms_conditions_label: "Terms & Conditions",

    // Region
    footer_region_label: "Change Region",
    footer_region_options_au_label: "Australia",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",

    // Social
    footer_social_label: "Connect with us",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube"
};
